var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgEdit = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.42201 15.0023H12.954C13.3311 15.0023 13.6928 14.8524 13.9595 14.5857C14.2262 14.319 14.376 13.9573 14.376 13.5801V8.90718H13.5634V13.5801C13.5634 13.7417 13.4992 13.8968 13.3849 14.0111C13.2706 14.1254 13.1156 14.1896 12.954 14.1896H4.42201C4.26038 14.1896 4.10536 14.1254 3.99107 14.0111C3.87678 13.8968 3.81258 13.7417 3.81258 13.5801V5.04696C3.81258 4.88531 3.87678 4.73028 3.99107 4.61597C4.10536 4.50167 4.26038 4.43745 4.42201 4.43745H9.09429V3.62477H4.42201C4.04557 3.62477 3.68449 3.77405 3.41793 4.03988C3.15137 4.30572 3.00108 4.66641 3.00001 5.04289V13.576C2.99947 13.7631 3.03586 13.9485 3.10708 14.1215C3.1783 14.2945 3.28296 14.4518 3.41506 14.5843C3.54716 14.7168 3.7041 14.8219 3.87689 14.8936C4.04968 14.9653 4.23492 15.0023 4.42201 15.0023Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3591 2.34481C15.1278 2.12351 14.82 2 14.4998 2C14.1797 2 13.8719 2.12351 13.6405 2.34481L8.0663 7.91572C7.91125 8.07257 7.79447 8.26307 7.72502 8.47241L7.08308 10.3903C7.05996 10.4522 7.05227 10.5188 7.06069 10.5844C7.0691 10.6499 7.09337 10.7124 7.1314 10.7664C7.16942 10.8205 7.22004 10.8644 7.27888 10.8945C7.33772 10.9245 7.40299 10.9398 7.46906 10.9389C7.5122 10.9447 7.55593 10.9447 7.59907 10.9389L9.50048 10.2644C9.70979 10.1949 9.90027 10.0781 10.0571 9.92304L15.6435 4.35213C15.8718 4.12356 16 3.81373 16 3.49069C16 3.16765 15.8718 2.85782 15.6435 2.62925L15.3591 2.34481ZM15.0707 3.77513L9.50048 9.3501C9.43353 9.41545 9.35311 9.46538 9.26484 9.49638L8.11505 9.87834L8.49696 8.7284C8.52796 8.64012 8.57788 8.55968 8.64322 8.49272L14.2134 2.91775C14.291 2.84713 14.3929 2.80927 14.4978 2.8121C14.6044 2.81255 14.7065 2.85487 14.7822 2.92994L15.0707 3.21844C15.1457 3.29413 15.188 3.39628 15.1885 3.50288C15.1849 3.60524 15.1428 3.70247 15.0707 3.77513Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgEdit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/edit.63895d2493002a51728da8ed22ed7151.svg";